// useTonDeposit.js - Hook for handling TON deposit transactions
import { useTonConnectUI, useTonAddress } from '@tonconnect/ui-react';

export const useTonDeposit = () => {
  const [tonConnectUI] = useTonConnectUI();
  const userAddress = useTonAddress();  // Your app's receiving address for deposits (replace with your actual address)
  // This is where all TON payments will be received
  // Make sure this is a TESTNET address when testing!
  const DEPOSIT_ADDRESS = "0QCsEG8VkGtHo9pp42yCwOvCA0qtrzoXjX8umpRd03-mfRWp"; // Your testnet address

  const sendDepositTransaction = async (tonAmount) => {
    if (!userAddress) {
      // Open TON Connect modal if wallet is not connected
      tonConnectUI.openModal();
      return { success: false, error: 'Wallet not connected' };
    }

    try {
      // For testnet, we'll use 0.1 TON for all purchases as requested
      const actualAmount = 0.1;
      
      // Convert to nanotons (1 TON = 1,000,000,000 nanotons)
      const nanotons = Math.floor(actualAmount * 1000000000);
      
      const transaction = {
        validUntil: Math.floor(Date.now() / 1000) + 300, // Valid for 5 minutes (in seconds, not milliseconds)
        messages: [
          {
            address: DEPOSIT_ADDRESS,
            amount: nanotons.toString(), // Must be string
            payload: "" // Empty payload for simple transfer
          }
        ]
      };      console.log('Sending TON deposit transaction:', {
        originalAmount: tonAmount,
        actualAmount: actualAmount,
        nanotons: nanotons,
        address: DEPOSIT_ADDRESS,
        validUntil: transaction.validUntil,
        userAddress: userAddress
      });

      const result = await tonConnectUI.sendTransaction(transaction);
      
      // Transaction was sent successfully
      console.log('Deposit transaction sent successfully:', result);
      
      return {
        success: true,
        result: result,
        amount: actualAmount,
        transactionHash: result
      };

    } catch (error) {
      console.error('Error sending deposit transaction:', error);
      
      // Handle different types of errors
      if (error.message && error.message.includes('User declined')) {
        return {
          success: false,
          error: 'Transaction was cancelled by user'
        };
      }
      
      if (error.message && error.message.includes('Insufficient funds')) {
        return {
          success: false,
          error: 'Insufficient funds in wallet'
        };
      }
      
      return {
        success: false,
        error: error.message || 'Failed to send transaction'
      };
    }
  };

  return {
    sendDepositTransaction,
    isConnected: !!userAddress,
    userAddress,
    openConnectModal: () => tonConnectUI.openModal()
  };
};
